import * as z$1 from "zod/v4";
//#region src/schemas/daemon/windows-user-task.ts
const windowsUserTaskRequestSchema = z$1.strictObject({
	name: z$1.string().min(1),
	legacyScript: z$1.string().min(1),
	operation: z$1.enum([
		"install",
		"status",
		"start",
		"stop",
		"enable",
		"disable",
		"uninstall"
	]),
	executable: z$1.string().optional(),
	arguments: z$1.string().optional(),
	workingDirectory: z$1.string().optional(),
	periodic: z$1.boolean().optional()
});
const windowsUserTaskStatusSchema = z$1.strictObject({
	installed: z$1.boolean(),
	running: z$1.boolean(),
	enabled: z$1.boolean(),
	legacy: z$1.boolean(),
	actionArguments: z$1.string().nullable()
});
const windowsUserTaskActionSchema = z$1.strictObject({
	executable: z$1.string().min(1),
	args: z$1.array(z$1.string()),
	env: z$1.record(z$1.string(), z$1.string()),
	logPath: z$1.string().min(1)
});
//#endregion
export { windowsUserTaskActionSchema, windowsUserTaskRequestSchema, windowsUserTaskStatusSchema };

//# sourceMappingURL=windows-user-task.js.map